
jQuery( document ).ready( function() {
  new(window.Marionette.Object.extend( {

      initialize() {
          this.listenTo( window.Backbone.Radio.channel( 'pikaday' ), 'init', this.modifyDatepicker );
      },

      modifyDatepicker( dateObject, fieldModel ) {
          var today=Date.now();

          switch(fieldModel.attributes['key'])
          {
            case 'date_rdv_sur_le_lieu_de_travail_choix_1':
            case 'date_rdv_sur_le_lieu_de_travail_choix_2':
            case 'date_rdv_sur_le_lieu_de_travail_choix_3':
              dateObject.pikaday.setMinDate( new Date(today) );

              dateObject.pikaday._o.disableDayFn = function( date ) {
                //var disabledDays = ['2017-04-28', '2017-04-29', '2017-04-30'];

                var dayOfWeek = date.getDay();
                var disabledDays =[0,1,2,4,6];

                if(disabledDays.indexOf(dayOfWeek)!==-1) {
                  return true;
                }
              };
              break;
            case 'date_rdv_domicile_choix_1':
            case 'date_rdv_domicile_choix_2':
            case 'date_rdv_domicile_choix_3':
                dateObject.pikaday.setMinDate( new Date(today) );

                dateObject.pikaday._o.disableDayFn = function( date ) {
                  //var disabledDays = ['2017-04-28', '2017-04-29', '2017-04-30'];

                  var dayOfWeek = date.getDay();
                  var disabledDays =[0,1,2,4,6];

                  if(disabledDays.indexOf(dayOfWeek)!==-1) {
                    return true;
                  }
                };
              break;
            case 'date_rdv_drivein_choix_1':
            case 'date_rdv_drivein_choix_2':
            case 'date_rdv_drivein_choix_3':
              dateObject.pikaday.setMinDate( new Date(today) );

              dateObject.pikaday._o.disableDayFn = function( date ) {
                var dayOfWeek = date.getDay();
                var disabledDays =[0,1,5,6];

                if(disabledDays.indexOf(dayOfWeek)!==-1) {
                  return true;
                }
              };
              break;
            case 'date_rdv_reparateur_choix_1':
            case 'date_rdv_reparateur_choix_2':
            case 'date_rdv_reparateur_choix_3':
              dateObject.pikaday.setMinDate( new Date(today) );

              dateObject.pikaday._o.disableDayFn = function( date ) {
                //var disabledDays = ['2017-04-28', '2017-04-29', '2017-04-30'];

                var dayOfWeek = date.getDay();
                var disabledDays =[0,6];

                if(disabledDays.indexOf(dayOfWeek)!==-1) {
                  return true;
                }
              };
              break;
            default: break;
          }

      },
  }));
});



// WEBPACK FOOTER //
// ./scripts/customdatepicker.js